const LOCATOR_NAME = "__tcfapiLocator"

/**
 * Keeps an initialized consent manager discoverable across Turbo visits.
 *
 * Ad iframes locate the TCF API's owning window through its named, empty locator
 * frame. Turbo replaces that frame with the body, while the API and its message
 * handler remain on window. Restore the locator in the incoming body before ad
 * controllers connect, reusing it when it is already in a cached snapshot.
 *
 * The CMP must create the initial locator itself: creating one before its
 * bootstrap could make it detect another CMP and skip API initialization.
 */
export function preserveTcfLocator(doc) {
  const ensureLocator = body => {
    if (body.querySelector(`iframe[name="${LOCATOR_NAME}"]`)) return

    const iframe = doc.createElement("iframe")
    iframe.name = LOCATOR_NAME
    iframe.hidden = true
    iframe.title = "Consent API locator"
    body.appendChild(iframe)
  }

  doc.addEventListener("turbo:before-render", event => {
    if (doc.querySelector(`iframe[name="${LOCATOR_NAME}"]`)) ensureLocator(event.detail.newBody)
  })
}
